import axios from "axios";
import firebase from "../../config/firebase";
import { toast } from "react-toastify";
export const login = (creds) => {
  return (dispatch) => {
    dispatch({
      type: "LOGIN_REQUEST",
    });
    firebase
      .auth()
      .signInWithEmailAndPassword(creds.email, creds.password)
      .then((data) => {
        firebase
          .firestore()
          .collection("users")
          .doc(data.user.uid)
          .onSnapshot((doc) => {
            const data = doc.exists ? doc.data() : null;
            if (!data) {
              toast.warn("User account not found. Please contact support.");
              dispatch({ type: "LOGIN_REQUEST_END" });
              return;
            }
            if (data.role === "admin" || data.role === "sub-admin") {
              dispatch({
                type: "LOGIN_SUCCESS",
                user: { id: doc.id, ...data },
                error: "",
              });
            } else {
              toast.warn("You are not allowed to access this panel");
            }
            dispatch({
              type: "LOGIN_REQUEST_END",
            });
          });
      })
      .catch((error) => {
        dispatch({
          type: "LOGIN_FAIL",
          uid: "",
          error: error,
        });
        dispatch({
          type: "LOGIN_REQUEST_END",
        });
        toast.warning(
          "Invalid credentials. Please try again with the correct information."
        );
      });
  };
};

export const logout = () => {
  return (dispatch) => {
    firebase
      .auth()
      .signOut()
      .then((data) => {
        dispatch({
          type: "LOGOUT_SUCCESS",
          uid: "",
          user: "",
          error: "",
        });
      })
      .catch((error) => {
        dispatch({
          type: "LOGOUT_FAIL",
          uid: "",
          error: error,
        });
        toast.warning(error.message);
      });
  };
};
export const forgetPassword = (email) => {
  return (dispatch) => {
    dispatch({
      type: "ACTION_FORGET_REQUEST",
    });
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then((res) => {
        dispatch({
          type: "ACTION_FORGET_REQUEST_END",
        });
        toast.success("Recovery Email Sent");
      })
      .catch((err) => {
        dispatch({
          type: "ACTION_FORGET_REQUEST_END",
        });
        toast.warning(err.message);
      });
  };
};
export const register = (obj, onComplete = () => {}) => {
  return async (dispatch) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(obj.email, obj.password)
      .then((data) => {
        let newObj = {
          role: "sub-admin",
          email: obj.email,
          name: obj.name,
          createdAt: firebase.firestore.Timestamp.now(),
          permissions: obj.permissions,
        };
        firebase
          .firestore()
          .collection("users")
          .doc(data.user.uid)
          .set(newObj)
          .then((query) => {
            dispatch({
              type: "ADD_SUB_ADMIN",
              payload: { id: data.user.uid, ...newObj },
            });
            let emailData = `You are now a sub admin in the FHP platform. Your email is: ${obj.email}. Please use the password provided by the administrator to log in.`;
            const options = {
              to: obj.email,
              subject: "Make for sub amin",
              text: emailData,
            };
            axios.post(
              `${process.env.REACT_APP_FIREBASE_BASE_DOMAIN}/sendUserEmail`,
              options
            );
            onComplete();
            toast.success("Create Sub Admin Successfully");
          });
      })
      .catch((error) => {
        onComplete("error");
        alert(error);
        toast.warning(error.message);
      });
  };
};

export const getSubAdmins =
  (lastDocument, onComplete = () => {}) =>
  async (dispatch, getState) => {
    let query = firebase
      .firestore()
      .collection("users")
      .where("role", "==", "sub-admin")
      .orderBy("createdAt", "desc");
    if (lastDocument) {
      query = query.startAfter(lastDocument);
    }
    query
      .limit(5)
      .get()
      .then(async (snapshot) => {
        let temp_data = [];
        for (let doc of snapshot.docs) {
          temp_data.push({ id: doc.id, ...doc.data() });
        }
        const prevData = getState().requestSubAdmin?.subAdmins || [];
        dispatch({
          type: lastDocument ? "MORE_GET_SUB_ADMINS" : "GET_SUB_ADMINS",
          payload: {
            data: lastDocument ? [...prevData, ...temp_data] : temp_data,
            lastDocument:
              snapshot.docs.length > 0
                ? snapshot.docs[snapshot.docs.length - 1]
                : null,
            hasMore: snapshot.docs.length === 5,
          },
        });

        onComplete();
      });
  };

export const deleteSubAdmin =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    await firebase.firestore().collection("users").doc(id).delete();
    dispatch({ type: "DELETE_SUB_ADMIN", payload: id });
    toast.success("Delete SubAdmin Successfully");
    onComplete();
  };
export const updateSubAdmin =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    await firebase.firestore().collection("users").doc(data.id).update({
      name: data.name,
      email: data.email,
      permissions: data.permissions,
    });
    dispatch({ type: "UPGRADE_SUB_ADMIN_DATA", payload: data });
    toast.success("Update data successfully");
    onComplete();
  };
